export class Anonyme {
    text1: string;
    text2: string;
    text3: string;
    text4: string;
    text5: string;

    d1: number;
    d2: number;
    d3: number;
    d4: number;

    l1: number;
    l2: number;
    l3: number;
    l4: number;

    b1: boolean;
    b2: boolean;
}